import { render } from "./CloneBackupOffering.vue?vue&type=template&id=81ab3952&scoped=true"
import script from "./CloneBackupOffering.vue?vue&type=script&lang=js"
export * from "./CloneBackupOffering.vue?vue&type=script&lang=js"

import "./CloneBackupOffering.vue?vue&type=style&index=0&id=81ab3952&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ab3952"]])

export default __exports__